/**
 * Writes {@code value} to the system clipboard.
 *
 * <p>Rejects when the value is empty or the Clipboard API is unavailable (an insecure context or an unsupported
 * browser), and when the underlying write is denied — so callers can surface their own success / failure message
 * from a single {@code .then()/.catch()} without repeating the availability check.
 *
 * @param value the text to copy
 * @return a promise that resolves once the text is on the clipboard and rejects if it could not be written
 */
export function copyToClipboard(value: string | null | undefined): Promise<void>
{
    if (!value || !navigator.clipboard?.writeText)
    {
        return Promise.reject(new Error('Clipboard is not available.'));
    }
    return navigator.clipboard.writeText(value);
}
